import { Widget, WIDGET_IMAGE } from "@gaming/srvg-classes-core";


export class ImageWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#imageWidget';
        super( options );

        this.name = 'widgetimage';
        this.widgetName = options.widgetName || WIDGET_IMAGE;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addImageWidget();
        super.handleDomInstantiated();
    }

    /**
     * add text widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addImageWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

}